import { Text } from '@main/complykit';
import { useParams } from '@tanstack/react-router';
import { FC, useEffect } from 'react';

import { useBackofficeDispatch } from '../../hooks/redux-toolkit-hooks';
import { previewFile } from './slice';

export const FileViewer: FC = () => {
  const params = useParams({ from: '/auth/file/$fileId' });
  const fileIdToView = params.fileId;
  const dispatch = useBackofficeDispatch();

  useEffect(() => {
    dispatch(previewFile({ fileId: fileIdToView }));
  }, [fileIdToView, dispatch]);

  return <Text>File preview section</Text>;
};
